<div [attr.id]="section().id" class="bg-grey-10" id="content-signup">
  <div class="h-layout p-3xl">
    <div class="flex flex-col gap-3xl md:flex-row md:px-lg lg:px-3xl">
      <div class="flex items-center md:w-1/2 lg:w-7/12">
        <div class="space-y-md text-center md:text-left">
          <p role="heading" aria-level="2" class="heading-2xl text-balance">{{ section().title }}</p>
          <p class="text-pretty">{{ section().description }}</p>
        </div>
      </div>
      <div class="md:w-1/2 lg:w-5/12">
        <cft-progressive-disclosure-box
          *transloco="let t"
          [heading]="section().form.title"
          [buttonText]="section().form.buttonLabel"
          (buttonClicked)="signup($event)"
          class="w-full"
        >
          <img
            [ngSrc]="section().image.url"
            [alt]="section().image.title || ''"
            class="h-24 object-cover"
            fill
            content="banner"
          />
          <form content="form" [formGroup]="form">
            <cft-form-field>
              <label for="firstName">
                {{ t('signupSection.firstNameLabel') }}
              </label>
              <input id="firstName" [formControl]="controls.firstName" />
            </cft-form-field>
            <cft-form-field>
              <label for="lastName">
                {{ t('signupSection.lastNameLabel') }}
              </label>
              <input id="lastName" [formControl]="controls.lastName" />
            </cft-form-field>
            <cft-form-field>
              <label for="email">
                {{ t('signupSection.emailLabel') }}
              </label>
              <input id="email" [formControl]="controls.email" />
            </cft-form-field>
          </form>
          <div content="foot-note" class="flex gap-xs text-left text-sm font-medium">
            <fa-icon [icon]="lockIcon"></fa-icon>
            <span [innerHTML]="t('signupSection.privacyText')"></span>
          </div>
        </cft-progressive-disclosure-box>
      </div>
    </div>
  </div>
</div>
